import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals, AuthenData } from '../globals/globals';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import { PORequest, POResponse, DocumentResponse, DocumentLineResponse, PaymentBankResponse, PaymentBankDetailResponse, ReportInvoiceResponse, ReportPaymentResponse, PaymentBankReportResponse, ReportSumPaymentResponse } from '../model/criteria/purchase';

@Injectable()
export class POServices {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();
    constructor(private http: HttpClient, private global: Globals) { }

    public getPaymentToken(): any {
        return JSON.parse(localStorage.getItem('tokenPayment'));
    }

    public getSummaryPaymentToken(): any {
        return JSON.parse(localStorage.getItem('tokenSummaryPayment'));
    }

    public getSPo(): any {
      return JSON.parse(localStorage.getItem('tokenSPo'));
  }

    public getPOSummaryPaymentToken(): any {
        return JSON.parse(localStorage.getItem('tokenPOSummaryPayment'));
    }

    find(criteria): Observable<POResponse> {
        return this.http.post<POResponse>(this.global.BaseApiUrl + 'api/competency/management/find', criteria)
    }
    findDocument(criteria): Observable<DocumentResponse> {
        return this.http.post<DocumentResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentHead', criteria)
    }
    findDocumentSO(criteria): Observable<DocumentResponse> {
        return this.http.post<DocumentResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentHeadSO', criteria)
    }

    findPayment(criteria): Observable<DocumentResponse> {
        return this.http.post<DocumentResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentPayment', criteria)
    }

    findPoLine(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentLine', criteria)
    }

    findPoEditLine(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/DocumentLineEdit', criteria)
  }

    findSoLine(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentSOLine', criteria)
    }

    findSoByItem(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/GetDocumentHeadSOByITem', criteria)
    }

    findPoByItem(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/GetDocumentHeadPOByITem', criteria)
    }

    findDoLine(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/DocumentDO', criteria)
    }

    SavePayment(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/SavePayment', criteria)
    }

    UpdatePayment(criteria): Observable<DocumentLineResponse> {
        return this.http.post<DocumentLineResponse>(this.global.BaseApiUrl + 'api/Document/Management/PaymentService', criteria)
    }

    findPaymentBank(criteria): Observable<PaymentBankResponse> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/PaymentBank', criteria)
    }

    findPaymentBankByDocumentNo(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/PaymentBankByDocumentNo', criteria)
    }

    findPaymentBankDetail(criteria): Observable<PaymentBankDetailResponse> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/PaymentBankDetail', criteria)
    }

    findReportInvoice(criteria): Observable<ReportInvoiceResponse> {
        return this.http.post<ReportInvoiceResponse>(this.global.BaseApiUrl + 'api/Report/Management/ReportInvoice', criteria)
    }

    findReportSumInvoice(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Report/Management/ReportSumInvoice', criteria)
  }

    approvedPO(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/ApprovedPO', criteria)
    }

    checkCreditApprovedPO(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/CheckCreditApprovedPO', criteria)
   }

    ReportPaymentBankDocument(criteria): any {
        return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/DownloadPaymentDetail', criteria, { observe: 'response', responseType: 'blob' })
    }

    renderReportInvoice(criteria): any {
        return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/RenderInvoiceReport', criteria, { observe: 'response', responseType: 'blob' })
    }

    findReportDO(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Report/Management/ReportDO', criteria)
    }

    renderReportDP(criteria): any {
        return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/RenderDRDOReport', criteria, { observe: 'response', responseType: 'blob' })
    }

    findReportPayment(criteria): Observable<ReportPaymentResponse> {
        return this.http.post<ReportPaymentResponse>(this.global.BaseApiUrl + 'api/Report/Management/ReportInvoicePayment', criteria)
    }

    renderReportPayment(criteria): any {
        return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/RenderPaymentReport', criteria, { observe: 'response', responseType: 'blob' })
    }

    cancelPayment(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/CancelPayment', criteria)
    }

    cancelPayslip(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/CancelPayslip', criteria)
  }

    editSO(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/EditSO', criteria)
    }

    editShipment(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/EditShipment', criteria)
    }

    uploadPayslip(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/UploadPayslip', criteria)
   }

   confrimPayslip(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/ConfirmPayslip', criteria)
   }

   findPaymentBankReport(criteria): Observable<PaymentBankReportResponse> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Report/Management/PaymentBankReport', criteria)
   }

  renderReportPaymentBank(criteria): any {
  return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/RenderPaymentBankReport', criteria, { observe: 'response', responseType: 'blob' })
  }

  renderReportPO(criteria): any {
    return this.http.post(this.global.BaseApiUrl + 'api/Report/Management/RenderPOReport', criteria, { observe: 'response', responseType: 'blob' })
}

cancelPO(criteria): Observable<any> {
  return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/CancelPO', criteria)
}

}



// WEBPACK FOOTER //
// ./src/app/services/purchase.services.ts